import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  Select,
  FormControl,
  MenuItem,
  Tooltip,
  Menu,
  TableContainer,
  useTheme,
} from "@material-ui/core";
import axios from "axios";
import apiConfigs from "../../config/config";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useDispatch, useSelector } from "react-redux";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import { getReport } from "../../store/action";
import {
  getAllCandidateList,
  getAllCustomerList,
  getAllHospitalsList,
  getSpecialitiesList,
  getStaffDetailList,
  getUmbrellDetailList,
  getWardByHospitalList,
} from "../../store/action/dropdown/dropdownAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment/moment";
import { customEnLocale } from "../../helper/customLocale";
import Loading from "../../components/Loading/Loading";
import { GetApp, Visibility } from "@material-ui/icons";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TablePaginationControls from "../../components/TablePaginationControls";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 24,
    background: theme.palette.background.main
  },
  container: {
    maxHeight: "calc(100vh - 260px)",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    cursor: "pointer",
    // color: theme.palette.secondary.main,
    gap: 4,
  },
  formControl: {
    width: "24%",
    marginTop: "10px",
  },
  searchIcondet: {
    marginRight: "14px",
  },
}));

const ViewReports = ({ match }) => {
  const classes = useStyle();
  const theme = useTheme();
  const dispatch = useDispatch();
  const tabList = ["COMPLETED"];
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchData, setSearchData] = useState({ search: "" });
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [bookingNotify, setBookingNotify] = useState(false);
  const [umbrella, setUmbrella] = useState([]);
  const [speciality, setSpeciality] = useState([]);
  const [hospitalList, setHospitalList] = useState();
  const [getTrustId, setTrustId] = useState();
  const [getHospitalId, setHospitalId] = useState();
  const [wardList, setWardList] = useState([]);
  const [staff, setStaff] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("date");
  const [selectedReport, setSelectedReport] = useState(0);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  const { bookingItem, loading, shiftStatusSuccess } = useSelector(
    (state) => state.booking
  );

  const [trust, setTrust] = useState([]);
  const today = new Date();
  const defaultStartDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

  const [data, setData] = useState({
    specialty: "",
    customer: "",
    site: "",
    ward: "",
    consultants: "",
    candidate: "",
    start_date: moment(defaultStartDate).format("yyyy-MM-DD"),
    end_date: moment(today).format("yyyy-MM-DD"),
    framework: "",
    trust_id: "",
    umbrella_id: "",
    type: "asc",
    column_name: "date",
    report_type: "",
  });

  const getBookingList = (pageNo = 1, perPage = 15, type = order, column_name = orderBy) => {
    dispatch(getReport({ pageNo, perPage, data, type, column_name }));
  };

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (pageNo, value) => {
    let status = tabList[activeIndex];
    setPage(value);
    setTimeout(getBookingList(value, searchData.search), 2000);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing items per page
    getBookingList(1, newPerPage);
  };

  const reportHandleChange = (event, value) => {
    setSelectedReport(event.target.value);

    setData({ ...data, report_type: event.target.value });
    tempReportHandle(event.target.value);
  };

  const tempReportHandle = (reportValue) => {
    let data1 = {
      specialty: "",
      customer: "",
      site: "",
      ward: "",
      consultants: "",
      candidate: "",
      start_date: data.start_date
        ? moment(data.start_date).format("yyyy-MM-DD")
        : moment(defaultStartDate).format("yyyy-MM-DD"),
      end_date: data.end_date
        ? moment(data.end_date).format("yyyy-MM-DD")
        : moment(today).format("yyyy-MM-DD"),
      trust_id: "",
      framework: "",
      umbrella_id: "",
      report_type: reportValue,
    };

    dispatch(getReport({ pageNo: 1, perPage, data: data1, order, orderBy }));
  };
  const getTrust = async () => {
    try {
      dispatch(
        getAllCustomerList((result) => {
          setTrust(result);
        })
      );
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getBookingList(page, searchData.search), 1000);
    handleMenuClose(true);
  };

  const handleClickDownload = async (event, value) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(
        `${apiConfigs.API_URL
        }api/organization/download-report-completed-booking?speciality=${data.specialty
        }&customer=${data.customer}&site=${data.site}&ward=${data.ward
        }&consultant=${data.consultants}&candidate=${data.candidate
        }&start_date=${moment(data.start_date).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(data.end_date).format("YYYY-MM-DD")}&trust_id=${data.trust_id
        }&umbrella_id=${data.umbrella_id
        }&act=export_csv&report_type=${selectedReport}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const url = response.data.data;
        var link = document.createElement("a");
        link.download = "Candidate.csv";
        link.href = url;
        link.target = "_blank";
        link.click();
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const getUmbrella = async () => {
    dispatch(
      getUmbrellDetailList((result) => {
        if (result?.data) {
          setUmbrella(result);
        }
      })
    );
  };
  const handleReset = () => {
    let type = "asc";
    let column_name = "date";
    let data = {
      specialty: "",
      customer: "",
      site: "",
      ward: "",
      consultants: "",
      candidate: "",
      start_date: moment(defaultStartDate).format("yyyy-MM-DD"),
      end_date: moment(today).format("yyyy-MM-DD"),
      trust_id: "",
      framework: "",
      umbrella_id: "",
    };
    setData(data);
    handleMenuClose(true);
    dispatch(getReport({ pageNo: 1, perPage, data, type, column_name }));
  };

  const getSpecialities = async () => {
    dispatch(
      getSpecialitiesList((result) => {
        if (result?.status === true) {
          setSpeciality(result);
        }
      })
    );
  };

  const gethospital = async () => {
    if (getTrustId) {
      let ID = moment(getTrustId).format("YYYY-MM-DD");
      dispatch(
        getAllHospitalsList(ID, (result) => {
          if (result?.status === true) {
            setHospitalList(result);
          }
        })
      );
    }
  };

  const getStaff = async () => {
    dispatch(
      getStaffDetailList((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getCandidates = async () => {
    dispatch(
      getAllCandidateList((result) => {
        if (result?.data) {
          setCandidates(result);
        }
      })
    );
  };
  useEffect(() => {
    if (getTrustId) {
      gethospital();
    }
  }, [getTrustId]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getBookingList(page, perPage);
    getTrust();
    getUmbrella();
    getSpecialities();
    getStaff();
    getCandidates();
  }, [orderBy, order, perPage]);

  const trustHandleChange = (event) => {
    data.site = "";
    data.ward = "";
    setTrustId(event.target.value);
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const dateHandler = (name, date) => {
    setData({ ...data, [name]: date });
    data.date = date;
    setTrustId(date);
  };
  const getWardType = async (hospitalId) => {
    dispatch(
      getWardByHospitalList(hospitalId, getTrustId, (result) => {
        if (result?.status === true) {
          setWardList(result);
        }
      })
    );
  };
  const hospitalHandleChange = (event) => {
    data.ward = "";
    setHospitalId(event.target.value);
    setData({ ...data, [event.target.name]: event.target.value });
    getWardType(event.target.value);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [visibleColumns, setVisibleColumns] = useState(
    headCells[0].map((col) => col.id) // all columns visible by default
  );

  const handleColumnToggle = (columnId) => {
    setVisibleColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId) // hide column
        : [...prev, columnId]                  // show column
    );
  };
  const { mode } = useContext(ThemeContext);
  useEffect(() => {
    document.documentElement.style.setProperty('--bgColor', theme?.palette?.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);
  return (
    <>
      {loading && <Loading open={loading} />}

      {bookingNotify && shiftStatusSuccess?.message && (
        <Notification data={shiftStatusSuccess?.message} status="success" />
      )}

      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>

        {/* Left: Report Selector */}
        <FormControl variant="outlined" size="small" className={classes.reportSelect} style={{ marginRight: 16 }}>
          <Select name="select-report" onChange={reportHandleChange} value={selectedReport}>
            <MenuItem value="0">Select Report Type</MenuItem>
            <MenuItem value="1">General</MenuItem>
            <MenuItem value="2">Timesheets</MenuItem>
            <MenuItem value="3">Framework</MenuItem>
            <MenuItem value="4">Factoring</MenuItem>
            <MenuItem value="5">MI</MenuItem>
            <MenuItem value="6">HTE-SIS</MenuItem>
            <MenuItem value="7">Invoice List</MenuItem>
          </Select>
        </FormControl>

        <Tooltip title="Filters">
          <Button onClick={handleMenu} style={{ marginRight: 16 }}>
            <FilterListIcon />
          </Button>
        </Tooltip>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={openMenu}
          onClose={handleMenuClose}
          className="filterBookingSearch"
        >
          <div className="customPopup" style={{ padding: "14px" }}>
            <Box className={classes.radioGroup}>
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexGrow={1}
                  flexWrap="wrap"
                >
                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={speciality?.data || []}
                      getOptionLabel={(option) => option?.speciality_name || ""}
                      value={
                        speciality?.data?.find((item) => item.id === data?.specialty) || null
                      }
                      onChange={(event, newValue) => {
                        trustHandleChange({
                          target: {
                            name: "specialty",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Specialty"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={trust?.data || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={trust?.data?.find((item) => item.id === data?.trust_id) || null}
                      onChange={(event, newValue) => {
                        trustHandleChange({
                          target: {
                            name: "trust_id",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Customer Name"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={hospitalList?.data || []}
                      getOptionLabel={(option) => option?.hospital_name || ""}
                      value={hospitalList?.data?.find((item) => item.id === data?.site) || null}
                      onChange={(event, newValue) => {
                        hospitalHandleChange({
                          target: {
                            name: "site",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Site"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />

                  </FormControl>

                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={wardList?.data || []}
                      getOptionLabel={(option) => option?.ward_name || ""}
                      value={wardList?.data?.find((w) => w.id === data?.ward) || null}
                      onChange={(event, newValue) => {
                        setData({
                          ...data,
                          ward: newValue ? newValue.id : "",
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ward"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={staff?.data || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={staff?.data?.find((c) => c.id === data?.consultants) || null}
                      onChange={(event, newValue) => {
                        setData({
                          ...data,
                          consultants: newValue ? newValue.id : "",
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Consultants"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>

                  <Box className={classes.formControl}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                      <DatePicker
                        id="date"
                        label="Start Date"
                        type="date"
                        name="start_date"
                        value={data.start_date}
                        variant="outlined"
                        onChange={(e) => dateHandler("start_date", e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ width: "100%" }}
                        renderInput={(props) => (
                          <TextField variant="outlined" {...props} />
                        )}
                        inputFormat="dd-MMM-yyyy"
                        fullWidth
                        firstDayOfWeek={1}
                      />
                    </LocalizationProvider>
                  </Box>

                  <Box className={classes.formControl}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                      <DatePicker
                        id="date"
                        value={data.end_date}
                        label="End Date"
                        type="date"
                        name="end_date"
                        variant="outlined"
                        onChange={(e) => dateHandler("end_date", e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ width: "100%" }}
                        renderInput={(props) => (
                          <TextField variant="outlined" {...props} />
                        )}
                        inputFormat="dd-MMM-yyyy"
                        fullWidth
                        firstDayOfWeek={1}
                      />
                    </LocalizationProvider>
                  </Box>

                  <FormControl className={classes.formControl} variant="outlined">
                    <Autocomplete
                      options={candidates?.data || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={candidates?.data?.find((c) => c.id === data?.candidate) || null}
                      onChange={(event, newValue) => {
                        trustHandleChange({
                          target: {
                            name: "candidate",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Candidate"
                          variant="outlined"
                          fullWidth
                          placeholder="Select Candidate"
                        />
                      )}
                    />

                  </FormControl>
                </Box>
              </Box>

              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexGrow={1}
                >

                  <FormControl variant="outlined" className={classes.formControl}>
                    <Autocomplete
                      options={umbrella?.data || []}
                      getOptionLabel={(option) => option?.name_umbrella || ""}
                      value={umbrella?.data?.find((u) => u.id === data?.umbrella_id) || null}
                      onChange={(event, newValue) => {
                        trustHandleChange({
                          target: {
                            name: "umbrella_id",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Umbrella Name"
                          variant="outlined"
                          fullWidth
                          placeholder="Select Umbrella"
                        />
                      )}
                    />
                  </FormControl>

                  <Box className={classes.formControl}>
                    <TextField
                      value={data.framework}
                      label="Framework"
                      type="text"
                      name="framework"
                      variant="outlined"
                      onChange={trustHandleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{ width: "100%" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                    }}
                    className={classes.formControl}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.searchIcondet}
                      onClick={handleClickSearch}
                    >
                      Search
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  </Box>
                  <Box className={classes.formControl}></Box>
                </Box>
              </Box>
            </Box>
          </div>
        </Menu>

        {bookingItem?.data &&
          <Button variant="contained" color="secondary" onClick={handleClickDownload}>
            <GetApp /> Download
          </Button>
        }

        <EnhancedTableToolbar
          numSelected={0}
          visibleColumns={visibleColumns}
          handleColumnToggle={handleColumnToggle}
          headCells={headCells[0]}
        />
      </Box >

      <Paper className={classes.root} elevation={3}>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={bookingItem?.data?.data?.length}
              headCells={headCells[0]}
              visibleColumns={visibleColumns}

            />
            <TableBody>
              {bookingItem?.data?.data &&
                bookingItem?.data?.data.map((row, index) => {
                  const dateFormate = row.date ? row.date.toString().split("-").reverse().join("-") : "-";

                  const InvoicedateFormate = {
                    formattedDate: row?.invoice_date ? moment(row?.invoice_date).format("DD-MM-yyyy") : "-",
                  };

                  return (
                    <TableRow key={index}>
                      {visibleColumns.includes("id") && (
                        <TableCell scope="row" style={{ color: theme.palette.listItem }}>{bookingItem?.data?.from + index}</TableCell>
                      )}
                      {visibleColumns.includes("name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>
                          {row.name}
                        </TableCell>
                      )}
                      {visibleColumns.includes("candidate") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.candidate}</TableCell>
                      )}
                      {visibleColumns.includes("consultant_name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.consultant_name}</TableCell>
                      )}
                      {visibleColumns.includes("speciality_name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.speciality_name}</TableCell>
                      )}
                      {visibleColumns.includes("framework") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.framework}</TableCell>
                      )}
                      {visibleColumns.includes("hospital_name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.hospital_name}</TableCell>
                      )}
                      {visibleColumns.includes("ward_name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.ward_name}</TableCell>
                      )}
                      {visibleColumns.includes("grade_name") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.grade_name}</TableCell>
                      )}
                      {visibleColumns.includes("date") && (
                        <TableCell align="left" style={{ whiteSpace: "nowrap", color: theme.palette.listItem }}>{
                          dateFormate && moment(dateFormate).isValid() ? moment(dateFormate).format("DD-MMM-YYYY").toUpperCase() : " - "}</TableCell>
                      )}
                      {visibleColumns.includes("invoice_date") && (
                        <TableCell align="left" style={{ whiteSpace: "nowrap", color: theme.palette.listItem }}>
                          {InvoicedateFormate?.formattedDate}
                        </TableCell>
                      )}
                      {visibleColumns.includes("start_time") && (
                        <TableCell align="left" style={{ color: theme.palette.listItem }}>
                          {row.start_time} <br /> {row.end_time}
                        </TableCell>
                      )}
                      <TableCell align="left" className="stickyCell stickyAction">
                        {((loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some(p => p.toLowerCase() === "reports-view")) ||
                          (loginUserInfo?.role !== "STAFF")) && (
                            <Box
                              style={{ marginRight: "10px", marginLeft: "10px", cursor: "pointer" }}
                              onClick={() => onhandlClick(row.id)}
                              variant="outlined"
                              size="small"
                            >
                              <Visibility />
                            </Box>
                          )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {!bookingItem?.data && (
                <TableRow>
                  <TableCell scope="row" colSpan="12" align="center">
                    Sorry, booking not available!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={bookingItem?.data?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper>
    </>
  );
};

export default ViewReports;
